/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SubnetPerAvailabilityZone {
  /**
  * Availability zone.
  */
  'availabilityZone': string;
  /**
  * Subnet ID to use.
  */
  'subnetId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "availabilityZone",
      "baseName": "availabilityZone",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetId",
      "baseName": "subnetId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SubnetPerAvailabilityZone.attributeTypeMap;
  }

  public constructor() {
  }
}

